const BASE = import.meta.env.BASE_URL;

export function GameDie({ value, className = "" }: { value?: number; className?: string }) {
  if (!value || value < 1 || value > 6) return <span className={`die-face-empty ${className}`.trim()}>—</span>;
  return <img className={`die-face-image ${className}`.trim()} src={`${BASE}assets/game-icons/dice/die-${value}.png`} alt={`D6: ${value}`} draggable={false}/>;
}

export function DiceRollIcon({ className = "" }: { className?: string }) {
  return <img className={`dice-roll-icon ${className}`.trim()} src={`${BASE}assets/game-icons/dice/die-6.png`} alt="" aria-hidden="true" draggable={false}/>;
}

export function MapRandomizerIcon({ className = "" }: { className?: string }) {
  return <img className={`map-randomizer-icon ${className}`.trim()} src={`${BASE}assets/game-icons/map-randomizer/randomize-map.png`} alt="" aria-hidden="true" draggable={false}/>;
}
